import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { RoleService } from '../../../service/role.service';
import { RoleState } from '../../../store/Role/RoleReducer';
import { ApplicationDto, PermissionDto, RoleDto } from '@clearing-hub/common';
import { AddRole } from '../../../store/Role/RoleActions';
import { initPermissionSelector } from '../../../store/Role/RoleSelector';
import { CreateRoleCommand } from '@clearing-hub/command';
import { CreateRoleForm } from '../../../model/CreateRoleForm';

@Component({
  selector: 'fxch-create-role',
  templateUrl: './create-role.component.html',
  styleUrls: ['./create-role.component.scss']
})
export class CreateRoleComponent implements OnInit, OnDestroy {

  private subscriptions: Array<Subscription> = new Array<Subscription>();

  roleForm: FormGroup<CreateRoleForm>;
  role: RoleDto;
  application: ApplicationDto;
  permissions: Array<PermissionDto>;

  constructor(private readonly fb: FormBuilder,
              private readonly modalRef: BsModalRef,
              private readonly roleService: RoleService,
              private readonly roleStore: Store<RoleState>) {
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.roleStore.select(initPermissionSelector).subscribe((permissions) => {
        this.permissions = Object.values(permissions);
      })
    );
    this.roleForm = this.fb.group({
      name: new FormControl(null),
      permissions: new FormControl(null),
      description: new FormControl<string>(''),
      application: new FormControl<ApplicationDto>(this.application)
    });
  }

  create(): void {
    const command: CreateRoleCommand = {
      name: this.roleForm.value.name,
      applicationId: this.roleForm.value.application.id,
      permissionIds: this.roleForm.value.permissions.map(p => p.id),
      description: this.roleForm.value.description
    }
    this.roleService.createRole(command).subscribe((role) => {
      this.roleStore.dispatch(new AddRole(role));
      this.modalRef.hide();
    })
  }

  close(): void {
    this.modalRef.hide();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
